<template>
  <b-row class="mt-3">
    <b-col md="3" class="lead">
      {{ label }}
      <i class="ic-tooltip" v-b-popover.hover="popoverContent"> </i>
    </b-col>
    <b-col md="9">
      <b-container class="bg-white rounded p-4 shadow-sm">
        <b-row v-for="(item, index) in cappingData" :key="index">
          <b-col cols="10" md="5" class="pr-0 pr-md-3">
            <b-form-group label="Limit" label-class="font-weight-bold">
              <numeric-input v-model="item.limit" placeholder="0" />
            </b-form-group>
          </b-col>
          <b-col cols="10" md="5" class="pr-0">
            <b-form-group
              :invalid-feedback="
                $parent.getInvalidFeedback(field, index, 'frequency')
              "
              :state="$parent.validateState(field, index, 'frequency')"
            >
              <template slot="label">
                <div class="font-weight-bold">
                  Frequency
                  <span class="font-weight-bold text-danger ml-1">*</span>
                </div>
              </template>
              <b-dropdown
                variant="link"
                class="custom-dropdown w-100"
                no-caret
                menu-class="w-100"
              >
                <template slot="button-content">
                  <b-container>
                    <b-row>
                      <b-col class="text-left pl-0">
                        {{
                          getFrequency(item.frequency)
                            ? getFrequency(item.frequency).text
                            : "Select"
                        }}
                      </b-col>
                      <b-col class="text-right pr-0">
                        <img
                          src="@/assets/images/dropdown.svg"
                          alt="Dropdown"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                </template>
                <b-dropdown-item
                  v-for="(option, index) in frequencyOptions"
                  :key="index"
                  :value="option.value"
                  @click="item.frequency = option.value"
                  :disabled="selectedFrequencies.includes(option.value)"
                >
                  {{ option.text }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
          </b-col>
          <b-col
            cols="2"
            md="1"
            class="d-flex flex-column justify-content-center align-items-center"
          >
            <i
              v-if="cappingData.length > 1"
              class="bi bi-x-circle-fill text-muted cursor-pointer"
              aria-hidden="true"
              v-b-popover.hover="'Remove'"
              @click="removeItem(index)"
            ></i>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col md="3" class="mx-auto">
            <b-btn
              v-if="cappingData.length < fieldsLimit"
              block
              variant="light"
              class="text-primary font-weight-bold"
              @click="addItem"
            >
              Add
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>
import NumericInput from "@/components/common/NumericInput.vue";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    popoverContent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      frequencyOptions: [
        { text: "Hour", value: "hour" },
        { text: "Day", value: "day" },
        { text: "Week", value: "week" },
        { text: "Month", value: "month" },
        { text: "Year", value: "year" },
      ],
      fieldsLimit: 5,
    };
  },
  computed: {
    ...mapState("wallet", ["cappingFields"]),
    ...mapFields("wallet", ["cappingDetails", "cappingFieldsToDelete"]),
    cappingData() {
      return this.field in this.cappingDetails
        ? this.cappingDetails[this.field]
        : [];
    },
    selectedFrequencies() {
      return this.cappingData.map(({ frequency }) => frequency);
    },
  },
  methods: {
    getFrequency(item) {
      return this.frequencyOptions.find(({ value }) => value === item);
    },
    addItem() {
      this.cappingDetails[this.field].push({ ...this.cappingFields });
    },
    removeItem(index) {
      const item = this.cappingDetails[this.field][index];

      if ("capping_type_setting_uuid" in item) {
        item.action = "delete";
        this.cappingFieldsToDelete[this.field].push(item);
      }

      this.cappingData.splice(index, 1);
    },
  },
  components: {
    NumericInput,
  },
};
</script>

<style lang="scss" scoped>
.btn {
  &:hover {
    background-color: #f8f9f9;
  }
  &:focus {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    box-shadow: none;
  }
}
</style>